
import partnersUsHeader from "@/components/partners/partnersUs/partnersUsHeader.vue";
import partnersUsBenefits from "@/components/partners/partnersUs/partnersUsBenefits.vue";
import baseSponsorScroll from "@/components/base/BaseSponsorScroll.vue";
import baseTextSection from "@/components/base/BaseTextSection.vue";
import {sendAnalyticsEvent} from "@/plugins/helper";
export default {
  components: {
    partnersUsHeader,
    partnersUsBenefits,
    baseSponsorScroll,
    baseTextSection,
  },
  data() {
    return {
      partnersUsIcons: ['amazon', 'cocaCola', 'pg', 'diageo', 'walmart', 'kfc', 'bimbo', 'volkswagen', 'colgate', 'amazon', 'bimbo', 'pg', 'walmart',]
    }
  },
  methods: {
    fireEvent() {
      sendAnalyticsEvent("learn_more_click", {
        "device_time": Math.round(Date.now() / 1000),
        "button": 'Get in Touch'
      })
      this.$router.push('/get-in-touch')
    }
  }
}
